<template>
    <!-- The mail client's own shell: the three panes fill the window and nothing
         scrolls but the panes themselves (views/mail/Mailbox.vue).

         It paints NOTHING — the canvas is the body rule in theme/theme.css, and
         each pane states its own surface: the folder sidebar is the chrome, the
         list and the reading pane are panels. The dynamic viewport unit, not the
         static one, for the reason the sign-in layout states. -->
    <div class="h-dvh w-screen overflow-hidden text-default">
        <slot />
    </div>
</template>
